import React, { useCallback, useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TopicHeader from '../TopicHeader/TopicHeader';
import Postcard from '../Postcard/Postcard';
import { Helmet } from 'react-helmet';
import { getTopics } from 'redux/modules/topics';
import { list as listQuestions } from 'redux/modules/questions';
import { searchToQuery } from 'utils/config';

const Topic = ({
  user,
  questions,
  dataByPage,
  total,
  location,
  page,
  topic,
  listQuestions,
}) => {
  const data = (dataByPage && dataByPage[page]) || [];
  const posts = data.map(questionId => questions[questionId]);
  const selectData = useMemo(
    () => [
      { name: 'Subscription', value: 'sub' },
      { name: 'Active', value: 'active' },
    ],
    []
  );
  const [search, setSearch] = useState('');
  const [select, setSelect] = useState('active');
  const handleSearch = useCallback(search => {
    setSearch(search);
  }, []);
  const handleSelect = useCallback(select => {
    setSelect(select);
  }, []);
  let list = [...posts];
  if (search)
    list = list.filter(({ question }) =>
      question.toLowerCase().includes(search)
    );
  if (select === 'active')
    list = list.sort((a, b) => b.createdAt - a.createdAt);
  else if (select === 'sub')
    list = list.sort((a, b) => !!b.subscribe - !!a.subscribe);
  const title = `${topic?.name} Discussion`;
  useEffect(() => {
    if (topic) {
      listQuestions({ filter: { topic: topic.value } });
    }
    setSearch('');
    setSelect('active');
  }, [listQuestions, topic]);
  if (!topic) return <div>Loading...</div>;
  return (
    <div>
      <Helmet>
        <title>{title} - Forums</title>
      </Helmet>
      <TopicHeader
        header={title}
        searchVal={search}
        selectVal={select}
        selectData={selectData}
        onSearch={handleSearch}
        onSelect={handleSelect}
      />
      {list.map(post => (
        <Postcard key={post._id} {...post} topic={topic.value} />
      ))}
      {!list.length && <div style={{ marginBottom: 50 }}>No posts</div>}
    </div>
  );
};

Topic.propTypes = {
  user: PropTypes.string,
  questions: PropTypes.object.isRequired,
  dataByPage: PropTypes.object,
  total: PropTypes.number,
  location: PropTypes.object,
  page: PropTypes.number,
  topic: PropTypes.object,
  listQuestions: PropTypes.func.isRequired,
};

Topic.defaultProps = {
  posts: [],
};

export default connect(
  (state, ownProps) => {
    const {
      auth: { user },
      entities: { questions },
    } = state;

    const topics = getTopics(state);

    const dataByPage = state.questions.idsByPage;
    const total = state.questions.total;
    const location = ownProps.location;
    const query = searchToQuery(location.search);
    const page = (query && query.page && parseInt(query.page, 10)) || 1;

    const topic = ownProps?.match?.params?.topic;

    return {
      user,
      questions,
      dataByPage,
      total,
      location,
      page,
      topic: topics?.[topic],
    };
  },
  { listQuestions }
)(Topic);
